import {
  Component, OnInit,
  Input, Output,
  EventEmitter,
  ViewChild, ElementRef
} from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { Global } from "../../classes/global";
import { SaleRecordService } from "../../services/saleRecord/sale-record.service";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FulfillService } from '../../services/fulfill/fulfill.service';

@Component({
  selector: 'app-buy-tiktok-label',
  templateUrl: './buy-tiktok-label.component.html',
  styleUrls: ['./buy-tiktok-label.component.scss']
})
export class BuyTiktokLabelComponent implements OnInit {

  @Input()
  saleRecord: any;
  @Output()
  buyLabelDone = new EventEmitter<string>();

  buyLabelRequest={
    dimension: {
      width: 14,
      height: 1,
      length: 13,
    },
    weight: 0.5,
    saleRecord: {}
  }

  // Display values for UK (in CM/GRAM) - these are converted from buyLabelRequest
  displayDimension = {
    width: 0,
    height: 0,
    length: 0,
  };
  displayWeight: number = 0;

  @ViewChild('buyTiktokLabelModal')
  buyTiktokLabelModal: ElementRef;

  modalResult: any;
  isUK: boolean = false;

  constructor(private toastr: ToastrService,
    public global: Global,
    private saleRecordService: SaleRecordService,
    private modalService: NgbModal,
    private fulfillService: FulfillService,
  ) {
  }

  ngOnInit(): void {
    this.buyLabelRequest.saleRecord = this.saleRecord;
    // Check if merchant is UK (merchantType 6 is TikTokUK)
    // Also check channel as fallback
    this.isUK = this.saleRecord.merchantType === 6 || 
                (this.saleRecord.channel && this.saleRecord.channel.toLowerCase().includes('uk'));
    
    // Set default values based on region
    // Backend expects inches/pounds, but we'll display CM/grams for UK
    if (this.isUK) {
      // UK defaults: 20 x 15 x 1 (CM) - 150 GRAM
      // Store in inches for backend: 20cm = 7.874in, 15cm = 5.906in, 1cm = 0.394in
      // Weight: 150g = 0.331lb
      this.buyLabelRequest.dimension.width = 7.874;
      this.buyLabelRequest.dimension.length = 5.906;
      this.buyLabelRequest.dimension.height = 0.394;
      this.buyLabelRequest.weight = 0.331;
      
      // Set display values in CM/GRAM
      this.updateDisplayValues();
    } else {
      // US defaults
      this.buyLabelRequest.dimension.width = 14;
      this.buyLabelRequest.dimension.length = 13;
      this.buyLabelRequest.dimension.height = 1;
      this.buyLabelRequest.weight = 0.5;
    }
  }

  // Convert between display units (CM/GRAM for UK) and backend units (INCH/LB)
  updateDisplayValues() {
    if (this.isUK) {
      // Convert from inches to CM for display
      this.displayDimension.width = this.buyLabelRequest.dimension.width * 2.54;
      this.displayDimension.length = this.buyLabelRequest.dimension.length * 2.54;
      this.displayDimension.height = this.buyLabelRequest.dimension.height * 2.54;
      // Convert from pounds to grams
      this.displayWeight = this.buyLabelRequest.weight * 453.592;
    } else {
      // For US, display values = backend values
      this.displayDimension.width = this.buyLabelRequest.dimension.width;
      this.displayDimension.length = this.buyLabelRequest.dimension.length;
      this.displayDimension.height = this.buyLabelRequest.dimension.height;
      this.displayWeight = this.buyLabelRequest.weight;
    }
  }

  // Convert from display units back to backend units
  updateBackendValues() {
    if (this.isUK) {
      // Convert from CM to inches
      this.buyLabelRequest.dimension.width = this.displayDimension.width / 2.54;
      this.buyLabelRequest.dimension.length = this.displayDimension.length / 2.54;
      this.buyLabelRequest.dimension.height = this.displayDimension.height / 2.54;
      // Convert from grams to pounds
      this.buyLabelRequest.weight = this.displayWeight / 453.592;
    } else {
      // For US, backend values = display values
      this.buyLabelRequest.dimension.width = this.displayDimension.width;
      this.buyLabelRequest.dimension.length = this.displayDimension.length;
      this.buyLabelRequest.dimension.height = this.displayDimension.height;
      this.buyLabelRequest.weight = this.displayWeight;
    }
  }

  openBuyLabelModal() {
    // Try to fetch dimension from backend
    const merchantId = this.saleRecord.merchantId;
    const productId = this.saleRecord.productLink.split('/')[this.saleRecord.productLink.split('/').length -1];
    if (merchantId && productId) {
      this.global.pageLoading = true;
      this.fulfillService.getTiktokProductDimension(merchantId, productId).subscribe(
        (data) => {
          // Backend returns dimensions - always convert to inches for backend storage
          if (this.isUK && data.unit === 'CM') {
            // Convert CM to inches for backend
            this.buyLabelRequest.dimension.width = data.width / 2.54;
            this.buyLabelRequest.dimension.height = data.height / 2.54;
            this.buyLabelRequest.dimension.length = data.length / 2.54;
            // Convert grams to pounds
            this.buyLabelRequest.weight = data.weight / 453.592;
          } else {
            this.buyLabelRequest.dimension.width = data.width;
            this.buyLabelRequest.dimension.height = data.height;
            this.buyLabelRequest.dimension.length = data.length;
            this.buyLabelRequest.weight = data.weight;
          }
          this.updateDisplayValues();
          this.global.pageLoading = false;
          this.modalResult = this.modalService.open(this.buyTiktokLabelModal);
        },
        (err) => {
          this.global.pageLoading = false;
          this.toastr.error('Không lấy được thông tin kích thước sản phẩm từ TikTok. Dùng mặc định.');
          this.modalResult = this.modalService.open(this.buyTiktokLabelModal);
        }
      );
    } else {
      this.modalResult = this.modalService.open(this.buyTiktokLabelModal);
    }
  }

  closeModal() {
    this.modalResult.close();
  }

  buyTiktokLabel() {
    // Convert display values back to backend format before sending
    this.updateBackendValues();
    
    this.global.pageLoading = true;
    this.saleRecordService.buyTiktokLabel(this.buyLabelRequest).subscribe((data) => {

      this.global.pageLoading = false;
      this.modalResult.close();

      this.toastr.success('Label được mua');
      this.buyLabelDone.emit();
    });
  }
}
